/** Wire / API verifyStatus values for fast-send templates. */
export enum FastSendTemplateVerifyStatus {
  Pending = 1,
  IsVerified = 2,
  UnVerified = 3,
  EnamadChecking = 4,
  XMAValidationChecking = 5,
}
